import { useAdminRequestScope } from "./useAdminRequestScope";
import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import type { Notify, Overview } from "./admin-types";

export function useAdminOverviewWorkspace({notify}: {notify: Notify}) {
  const scope = useAdminRequestScope(notify);
  const [data, setData] = useState<Overview | null>(null);
  const load = useCallback(() => {
    if (!scope.isMounted()) return;
    const request = scope.beginRead();
    void apiRequest<Overview>("/api/admin/overview").then(value => {
      if (scope.isCurrentRead(request)) setData(value);
    }).catch((error: unknown) => {
      if (scope.isCurrentRead(request)) scope.notify(error instanceof Error ? error.message : "Özet alınamadı.");
    });
  }, [scope]);
  useEffect(load, [load]);
  return { data, load };
}
